module.exports = __webpack_public_path__ + "static/media/modis2952.15c0e988.jpg";